import * as React from 'react';

import { StyleSheet, css } from '@coursera/coursera-ui';
import { SvgClose } from '@coursera/coursera-ui/svg';

import _t from 'i18n!nls/authentication';

type Props = React.HTMLProps<HTMLButtonElement>;

const styles = StyleSheet.create({
  close: {
    alignItems: 'center',
    background: 'transparent',
    border: 'none',
    color: '#2A73CC',
    cursor: 'pointer',
    display: 'inline-flex',
    fontSize: 'inherit',
    height: '50px',
    justifyContent: 'center',
    padding: '0',
    transition: 'background-color 250ms ease-out, box-shadow 250ms ease-out',
    width: '50px',
    ':focus': {
      backgroundColor: '#F3F8FF',
      boxShadow: '0 0 0 2px #FFFFFF, 0 0 0 3px #6A52E9, 0 0 0 4px #F3F8FF',
      outline: 'none',
    },
    '@media (hover:hover)': {
      ':hover': {
        backgroundColor: '#F3F8FF',
      },
    },
    '@media (min-width: 600px)': {
      borderRadius: '50%',
    },
  },
});

const CloseButton = ({ className, ...props }: Props) => (
  <button data-e2e="close-modal-button" {...css(className, styles.close)} {...props} type="button">
    <SvgClose aria-label={_t('Close modal')} />
  </button>
);

export default CloseButton;
